import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return (
    <nav className="flex items-center justify-center sm:justify-end">
      <ul className="flex items-center ">
        {/* Prev button */}
        <li>
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 border text-sm font-medium transition-all ${
              currentPage === 1
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-white text-gray-700 border-gray-300 hover:bg-custom-yellow hover:text-black"
            }`}
          >
            Prev
          </button>
        </li>

        {/* Page numbers */}
        {pages.map((num) => (
          <li key={num}>
            <button
              onClick={() => { onPageChange(num);  console.log(num);}}
              className={`px-3 py-1  border text-sm font-medium transition-all ${
                num === currentPage
                  ? "bg-custom-yellow text-black border-custom-yellow"
                  : "bg-white text-gray-700 border-gray-300 hover:bg-custom-yellow hover:text-black"
              }`}
            >
              {num}
            </button>
          </li>
        ))}

        {/* Next button */}
        <li>
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-3 py-1  border text-sm font-medium transition-all ${
              currentPage === totalPages
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-white text-gray-700 border-gray-300 hover:bg-custom-yellow hover:text-black"
            }`}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
